
const HOME_I18N = {
  es: {
    eyebrow:            "alvarotorresb.com · tools",
    title1:             "Cumplimiento de seguridad",
    title2:             "de la información",
    subheadline:        "Evalúa el estado de seguridad de tu organización frente a los principales marcos normativos.",
    soon:               "Próximamente",
    startBtn:           "Iniciar evaluación →",
    domains:            "dominios",
    questions:          "preguntas",
    time:               "Tiempo",
    sectionAssessments: "Assessments",
    sectionTools:       "Herramientas",
    toolsSoon:          "Próximamente",
    toolBtn:            "Abrir herramienta →",
  },
  en: {
    eyebrow:            "alvarotorresb.com · tools",
    title1:             "Information security",
    title2:             "compliance",
    subheadline:        "Assess your organisation's security posture against leading regulatory frameworks.",
    soon:               "Coming soon",
    startBtn:           "Start assessment →",
    domains:            "domains",
    questions:          "questions",
    time:               "Time",
    sectionAssessments: "Assessments",
    sectionTools:       "Tools",
    toolsSoon:          "Coming soon",
    toolBtn:            "Open tool →",
  },
};

const COMING_SOON = [];

const TOOLS_COMING_SOON = [
  {
    id: "gdpr-deadline",
    shortName: "Calculadora de plazos GDPR",
    description: {
      es: "Calcula el deadline de notificación a la autoridad de control (72h) y a los afectados según Arts. 33-34 RGPD.",
      en: "Calculate the notification deadline to the supervisory authority (72h) and to data subjects under Arts. 33-34 GDPR.",
    },
    badge: { es: "RGPD · Art. 33-34", en: "GDPR · Art. 33-34" },
    available: false,
  },
  {
    id: "gdpr-breach-register",
    shortName: "Registro de brechas GDPR",
    description: {
      es: "Registra y evalúa la notificabilidad de incidentes de seguridad según los criterios del Art. 33 RGPD.",
      en: "Log and assess the notifiability of security incidents under Art. 33 GDPR criteria.",
    },
    badge: { es: "RGPD · Art. 33", en: "GDPR · Art. 33" },
    available: true,
  },
  {
    id: "gdpr-docs",
    shortName: "Inventario de documentos GDPR",
    description: {
      es: "Inventario de documentos obligatorios bajo el RGPD con estado de cumplimiento y generadores.",
      en: "Inventory of mandatory GDPR documents with compliance status and generators.",
    },
    badge: { es: "RGPD · Documentación", en: "GDPR · Documentation" },
    available: false,
  },
  {
    id: "iso27001-controls",
    shortName: "Evaluador de controles ISO 27001",
    description: {
      es: "Evalúa la efectividad de los controles del Anexo A de ISO 27001:2022 implementados en tu organización.",
      en: "Assess the effectiveness of ISO 27001:2022 Annex A controls implemented in your organisation.",
    },
    badge: { es: "ISO 27001 · Anexo A", en: "ISO 27001 · Annex A" },
    available: false,
  },
];

function SectionLabel({ text }) {
  return (
    <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.62rem", color:"#1a5c3a", letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:"1.25rem" }}>
      {text}
    </div>
  );
}

function Card({ standard, lang, t, onSelect, ctaLabel }) {
  const isAvailable = standard.available;
  const meta = standard.meta || {};
  const timeVal = meta.timeEstimate?.[lang] || meta.timeEstimate?.es || "";

  return (
    <div
      onClick={() => isAvailable && onSelect(standard)}
      style={{
        background: isAvailable ? "#ffffff" : "#e5e1d9",
        border: "1px solid #d6d2ca",
        borderRadius: 12,
        padding: "1.5rem",
        cursor: isAvailable ? "pointer" : "default",
        opacity: isAvailable ? 1 : 0.72,
        transition: "border-color 0.15s, box-shadow 0.15s",
        display: "flex",
        flexDirection: "column",
      }}
      onMouseEnter={e => {
        if (!isAvailable) return;
        e.currentTarget.style.borderColor = "#0f2235";
        e.currentTarget.style.boxShadow = "0 2px 12px rgba(15,34,53,0.08)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.borderColor = "#d6d2ca";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* Badge row */}
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"1rem" }}>
        <span style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.6rem", color:"#1a5c3a", letterSpacing:"0.12em", textTransform:"uppercase" }}>
          {standard.badge?.[lang] || standard.shortName}
        </span>
        {!isAvailable && (
          <span style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.58rem", color:"#6b7280", background:"#d6d2ca80", borderRadius:20, padding:"0.2rem 0.6rem" }}>
            {t.soon}
          </span>
        )}
      </div>

      {/* Title & description */}
      <div style={{ fontFamily:"'Syne',sans-serif", fontSize:"1.15rem", fontWeight:700, color:"#0f2235", marginBottom:"0.5rem", lineHeight:1.3 }}>
        {standard.shortName}
      </div>
      <div style={{ fontFamily:"'Syne',sans-serif", fontSize:"0.75rem", color:"#6b7280", marginBottom:"1.25rem", lineHeight:1.55, flex:1 }}>
        {standard.description?.[lang]}
      </div>

      {/* Meta */}
      <div style={{ display:"flex", gap:"1.25rem" }}>
        {meta.domainCount && (
          <div>
            <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"1rem", fontWeight:500, color:"#1a5c3a" }}>{meta.domainCount}</div>
            <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.58rem", color:"#6b7280", textTransform:"uppercase", letterSpacing:"0.08em" }}>{t.domains}</div>
          </div>
        )}
        {meta.questionCount && (
          <div>
            <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"1rem", fontWeight:500, color:"#1a5c3a" }}>{meta.questionCount}</div>
            <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.58rem", color:"#6b7280", textTransform:"uppercase", letterSpacing:"0.08em" }}>{t.questions}</div>
          </div>
        )}
        {timeVal && (
          <div>
            <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"1rem", fontWeight:500, color:"#1a5c3a" }}>{timeVal}</div>
            <div style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.58rem", color:"#6b7280", textTransform:"uppercase", letterSpacing:"0.08em" }}>{t.time}</div>
          </div>
        )}
      </div>

      {/* CTA */}
      {isAvailable && (
        <div style={{ marginTop:"1.25rem", paddingTop:"1.25rem", borderTop:"1px solid #d6d2ca" }}>
          <span style={{ fontFamily:"'Syne',sans-serif", fontSize:"0.82rem", fontWeight:600, color:"#1a5c3a" }}>
            {ctaLabel || t.startBtn}
          </span>
        </div>
      )}
    </div>
  );
}

export default function HomeScreen({ standards, onSelect, onSelectTool, lang, onLangToggle }) {
  const t = HOME_I18N[lang];

  const allCards = [
    ...standards.map(s => ({ ...s, available: true })),
    ...COMING_SOON.filter(c => !standards.find(s => s.id === c.id)),
  ];

  return (
    <div style={{ minHeight:"100vh", background:"#eeeae3", fontFamily:"'Syne',sans-serif" }}>
      {/* Navbar */}
      <div style={{
        height: 52, background: "#eeeae3", borderBottom: "1px solid #d6d2ca",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "0 1.5rem", position: "sticky", top: 0, zIndex: 50,
        boxSizing: "border-box",
      }}>
        <div style={{ display:"flex", alignItems:"baseline", gap:"0.35rem", userSelect:"none" }}>
          <span style={{ fontFamily:"'Syne',sans-serif", color:"#0f2235", fontWeight:800, fontSize:"1rem" }}>AT.</span>
          <span style={{ fontFamily:"'Syne',sans-serif", color:"#1a5c3a", fontWeight:400, fontSize:"0.9rem" }}>· tools</span>
        </div>
        <div style={{ display:"flex", border:"1px solid #d6d2ca", borderRadius:6, overflow:"hidden" }}>
          {[
            { code:"es", label: "ESPAÑOL" },
            { code:"en", label: "ENGLISH" },
          ].map(({ code, label }) => {
            const active = lang === code;
            return (
              <button key={code} onClick={() => onLangToggle(code)} style={{
                background: active ? "#0f2235" : "transparent",
                color: active ? "#ffffff" : "#6b7280",
                border: "none", borderRadius: 0,
                padding: "0.3rem 0.75rem", cursor: "pointer",
                fontFamily: "'DM Mono',monospace", fontSize: "0.62rem",
                letterSpacing: "0.06em", transition: "all 0.15s",
              }}>
                {label}
              </button>
            );
          })}
        </div>
      </div>

      <div style={{ maxWidth:860, margin:"0 auto", padding:"5rem 1.5rem 4rem" }}>
        {/* Header */}
        <div style={{ marginBottom:"3.5rem" }}>
          <div style={{ display:"flex", alignItems:"center", gap:"0.75rem", marginBottom:"1.25rem" }}>
            <div style={{ width:28, height:2, background:"#1a5c3a", flexShrink:0 }} />
            <span style={{ fontFamily:"'DM Mono',monospace", fontSize:"0.62rem", color:"#1a5c3a", letterSpacing:"0.15em", textTransform:"uppercase" }}>{t.eyebrow}</span>
          </div>
          <h1 style={{ fontFamily:"'Syne',sans-serif", fontSize:"clamp(1.4rem,3vw,1.9rem)", fontWeight:700, color:"#0f2235", margin:"0 0 0.5rem", lineHeight:1.2 }}>
            {t.title1}<br/>{t.title2}
          </h1>
          <p style={{ fontFamily:"'Syne',sans-serif", fontSize:"0.95rem", color:"#6b7280", maxWidth:520, margin:"1rem 0 0", lineHeight:1.65 }}>
            {t.subheadline}
          </p>
        </div>

        {/* Assessments section */}
        <SectionLabel text={t.sectionAssessments} />
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(270px,1fr))", gap:"1.25rem" }}>
          {allCards.map(standard => (
            <Card key={standard.id} standard={standard} lang={lang} t={t} onSelect={onSelect} />
          ))}
        </div>

        {/* Divider */}
        <div style={{ height:1, background:"#d6d2ca", margin:"3rem 0" }} />

        {/* Tools section */}
        <SectionLabel text={t.sectionTools} />
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(270px,1fr))", gap:"1.25rem" }}>
          {TOOLS_COMING_SOON.map(tool => (
            <Card
              key={tool.id}
              standard={tool}
              lang={lang}
              t={t}
              onSelect={() => onSelectTool && onSelectTool(tool.id)}
              ctaLabel={t.toolBtn}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
